import React from 'react';
import classnames from 'classnames';

import MyShortcuts from './components/MyShortcuts';
import NewFeatures from './components/NewFeatures';

import type { IMyShortcutsProps } from './components/MyShortcuts';
import type { INewFeaturesProps } from './components/NewFeatures';

import './index.scss';

interface IMyShortcutsAndNewFeaturesCardProps extends IBaseProps {
  shortcutsTitle?: IMyShortcutsProps['title'];
  shortcutsActionText?: IMyShortcutsProps['actionText'];
  shortcutsMaxCount?: IMyShortcutsProps['maxCount'];
  newFeaturesTitle?: INewFeaturesProps['title'];
  newFeaturesActionText?: INewFeaturesProps['actionText'];
  newFeaturesHomeCount?: INewFeaturesProps['homeCount'];
  newFeaturesBatchSize?: INewFeaturesProps['batchSize'];
}

const MyShortcutsAndNewFeaturesCard: React.FC<IMyShortcutsAndNewFeaturesCardProps> = (props) => {
  const {
    style,
    className,
    shortcutsTitle,
    shortcutsActionText,
    shortcutsMaxCount,
    newFeaturesTitle,
    newFeaturesActionText,
    newFeaturesHomeCount,
    newFeaturesBatchSize,
  } = props;

  return (
    <div style={style} className={classnames('dbh-my-shortcuts-and-new-features-card', className)}>
      <MyShortcuts title={shortcutsTitle} actionText={shortcutsActionText} maxCount={shortcutsMaxCount} />
      <NewFeatures
        title={newFeaturesTitle}
        actionText={newFeaturesActionText}
        homeCount={newFeaturesHomeCount}
        batchSize={newFeaturesBatchSize}
      />
    </div>
  );
};

export default MyShortcutsAndNewFeaturesCard;
